import React, { useState } from "react";
import {
  getPublicSymbolSize,
  getStyle,
  getVisibilityStyle,
  getAdjustedFontSize,
} from "../Common/StylesHelper";
import { hexToRgba } from "utils/Utils";
import PublicPreviewPriceDisplay from "components/common/PublicPreviewPriceDisplay";
import DragScroll from "components/common/DragScroll";
import ProductDetailsModal from "./ProductDetailsModal";
import productGridPlaceholder from "assets/images/productGridPlaceholder.png";


const TextMenuGrid = ({
  products = [],
  config,
  styles,
  primaryColor,
  theme = {},
  layoutSettings,
  scrollDirection,
  currencyInfo,
  language,
  responsiveLayoutType,
  isApplyBlackColor,
  activeCategoryName,
}) => {
  return (
    <div className="product_grid_inner">
      <HorizontalProductGrid
        products={products}
        config={config}
        layoutSettings={layoutSettings}
        styles={styles}
        currencyInfo={currencyInfo}
        primaryColor={primaryColor}
        theme={theme}
        language={language}
        isApplyBlackColor={isApplyBlackColor}
        activeCategoryName={activeCategoryName}
      />
    </div>
  );
};

export default TextMenuGrid;

const HorizontalProductGrid = ({
  products = [],
  config,
  styles,
  primaryColor,
  currencyInfo,
  theme = {},
  layoutSettings,
  language,
  isApplyBlackColor,
  activeCategoryName,
}) => {
  const {
    showPreviewImage,
    showPrice,
    showCalorie,
    showTitle,
    showAllergens,
    showTags,
  } = config || {};

  const { width, height } = getPublicSymbolSize(styles?.productPrice?.size);
  const { allergenBackgroundColor } = theme || {};
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { itemSpacing, cardStyle, columns, itemAlignment } =
    layoutSettings?.productGrid || {};

  const {
    borderRadius,
    borderWidth,
    backgroundColor,
    backgroundOpacity,
    borderColor,
  } = cardStyle || {};

  const cardStyles = {
    marginTop: itemSpacing,
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius:"15px",
    backgroundColor: hexToRgba(backgroundColor, backgroundOpacity),
  };
  const { color } = getStyle(styles, "productTitle");

  return (
    <div className="horizontal_product_grid">
      <div className="category_name_wrapper">
        <span
          className="category_dot"
          style={{ backgroundColor: color }}
        ></span>
        <h3
          className="active_category"
          style={{
            ...getStyle(styles, "productTitle"),
            fontSize: getAdjustedFontSize(20, styles?.productTitle?.family),
          }}
        >
          {activeCategoryName?.categoryName}
        </h3>
      </div>
      {products?.map((product) => {
        const {
          productId = "",
          productTitle = "",
          productDescription = "",
          productPrice = "",
          productCalorie = "",
          imageUrl = "",
          allergens = [],
          tags = {},
          addonsOptions = {},
        } = product;

        const priceAndSizes = [
          ...(addonsOptions?.priceAndSizes || []),
          ...(addonsOptions?.modifierOptions || []),
        ];

        return (
          <div
            key={productId}
            className={`single_card text-menu-grid`}
            style={cardStyles}
            onClick={() => setSelectedProduct(product)}
          >
            {/* Image */}

            {/* Content */}
            <div className="content_wrapper w-100">
              <div className="d-flex gap-2">
                <div className="image_wrapper">
                  <img
                    src={imageUrl || productGridPlaceholder}
                    height={80}
                    width={80}
                  />
                </div>
                <div className="right_section text-menu">
                  <div className="d-flex justify-content-between">
                    <div className="tag_and_title_wrapper d-flex align-items-center title_tag_wrapper">
                      <h5
                        style={{
                          ...getStyle(styles, "productTitle"),
                          ...getVisibilityStyle(showTitle),
                          ...(isApplyBlackColor && { color: "#000" }),
                          fontSize: getAdjustedFontSize(14, styles?.productTitle?.family),
                        }}
                        className="in_2_line"
                      >
                        {productTitle}
                      </h5>
                      <div className="tag_wrapper">
                        {showTags && tags && tags?.label?.trim() && (
                          <span
                            className="static_tag"
                            style={{
                              backgroundColor: tags?.color || "#A47E51",
                              color: styles?.tags?.color || "#fff",
                            }}
                          >
                            {tags.label}
                          </span>
                        )}
                      </div>
                    </div>
                    {!priceAndSizes.length && (
                      <div className="price_wrapper">
                        <p
                          className="product-price ltr w_fit_content"
                          style={{
                            ...getStyle(styles, "productPrice"),
                            ...getVisibilityStyle(showPrice),
                            ...(isApplyBlackColor && { color: "#000" }),
                            fontSize: getAdjustedFontSize(16, styles?.productPrice?.family),
                          }}
                        >
                          <PublicPreviewPriceDisplay
                            currencyInfo={currencyInfo}
                            productPrice={productPrice}
                            width={14}
                            height={14}
                            primaryColor={
                              isApplyBlackColor
                                ? "#000"
                                : styles["productPrice"].color || primaryColor
                            }
                          />
                        </p>
                      </div>
                    )}
                  </div>

                  <div
                    className={`d-flex align-items-center card_center ${productCalorie?.trim() ? "with_calory" : "no_calory"}`}
                  >
                    <p
                      style={{
                        ...getStyle(styles, "productCalorie"),
                        ...getVisibilityStyle(showCalorie),
                        ...(isApplyBlackColor && { color: "#000" }),
                        fontSize: getAdjustedFontSize(12, styles?.productCalorie?.family),
                      }}
                      className="product_calorie w_fit_content"
                    >
                      {productCalorie}
                    </p>
                    {allergens?.length > 0 && showAllergens && tags ? (
                      <div
                        className={`allergens allergens_div ${
                          priceAndSizes.length > 0 ? "with-tags" : ""
                        }`}
                        style={{ maxWidth: "100%" }}
                      >
                        {/* <h5 style={getThemeFontStyles(theme)}>
                    {getAllergenText(language)}
                  </h5> */}
                        <DragScroll className="inner_section allergen_inner">
                          {allergens?.map((allergen, idx) => (
                            <div
                              key={idx}
                              className="inner_div"
                              style={{
                                "--theme-primary-color":
                                  allergenBackgroundColor,
                              }}
                            >
                              <img
                                src={allergen?.url}
                                width={15}
                                height={15}
                                alt=""
                              />
                            </div>
                          ))}
                        </DragScroll>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="addon_prices_wrapper">
                {priceAndSizes.length > 0 && (
                  <div className="price-and-sizes-container text-menu">
                    <DragScroll className="inner_section">
                      {priceAndSizes.map((sizeOption) => (
                        <div
                          key={sizeOption.id}
                          className="size-price-item text-menu"
                          style={{
                            borderColor:
                              { ...getStyle(styles, "productTitle") } || "#fff",
                          }}
                        >
                          <span
                            className="size-name"
                            title={sizeOption.name}
                            style={{
                              ...getStyle(styles, "productTitle"),
                              fontSize: getAdjustedFontSize(8, styles?.productTitle?.family),
                            }}
                          >
                            {sizeOption.name}
                          </span>
                          <span
                            className="size-price ltr w_fit_content"
                            title={`${sizeOption.price}`}
                            style={{
                              ...getStyle(styles, "productTitle"),
                              fontSize: getAdjustedFontSize(8, styles?.productTitle?.family),
                            }}
                          >
                            <PublicPreviewPriceDisplay
                              currencyInfo={currencyInfo}
                              productPrice={sizeOption.price}
                              width={10}
                              height={10}
                              primaryColor={
                                isApplyBlackColor
                                  ? "#000"
                                  : styles["productTitle"]?.color ||
                                    primaryColor
                              }
                            />
                          </span>
                        </div>
                      ))}
                    </DragScroll>
                  </div>
                )}
              </div>
            </div>
            {/* <div className="img_wrapper">
              <img
                src={imageUrl || productGridPlaceholder}
                alt={productTitle}
                style={{
                  width: 162,
                  height: 162,
                  objectFit: "contain",
                  borderRadius,
                  ...getVisibilityStyle(showPreviewImage),
                }}
              />
            </div> */}
          </div>
        );
      })}
      <ProductDetailsModal
        show={!!selectedProduct}
        product={selectedProduct}
        language={language}
        onHide={() => setSelectedProduct(null)}
        currencyInfo={currencyInfo}
        styles={styles}
        primaryColor={primaryColor}
        isApplyBlackColor={isApplyBlackColor}
        config={config}
        theme={theme}
      />
    </div>
  );
};
